export const KIND_OF_LEARNING_ANATOMY_QUESTION =
  'What kind of learning do you like the most?'

export const KIND_OF_LEARNING_ANATOMY_OPTION_KEYS = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
] as const
